import { api } from "./api";

// Accepts "48.9059°, -119.0113°", "48.9059, -119.0113", "48.9059 N 119.0113 W" etc.
const COORD_RE = /^\s*(-?\d{1,3}(?:\.\d+)?)\s*°?\s*([NSns])?\s*[,\s]\s*(-?\d{1,3}(?:\.\d+)?)\s*°?\s*([EWew])?\s*$/;

export const parseCoords = (query) => {
  const m = String(query || "").match(COORD_RE);
  if (!m) return null;
  let lat = parseFloat(m[1]);
  let lon = parseFloat(m[3]);
  if (m[2] && m[2].toUpperCase() === "S") lat = -Math.abs(lat);
  if (m[4] && m[4].toUpperCase() === "W") lon = -Math.abs(lon);
  if (Math.abs(lat) > 90 || Math.abs(lon) > 180) return null;
  return { lat, lon };
};

export const geocode = (query) => {
  const c = parseCoords(query);
  if (c) {
    return Promise.resolve([
      { lat: c.lat, lon: c.lon, display_name: `Coordinates ${c.lat.toFixed(4)}, ${c.lon.toFixed(4)}` },
    ]);
  }
  return api.post("/geocode", { query }).then((r) => r.data);
};

export const checkProximity = (locations) =>
  api.post("/proximity", { locations }).then((r) => r.data);

export const fetchFirePerimeters = (county, includeGeometry = true) =>
  api.get("/fire-perimeters", { params: { county, geometry: includeGeometry } })
    .then((r) => r.data);

// Compass label from bearing
export function compass(deg) {
  const dirs = ["N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE",
                "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW"];
  const idx = Math.round(((deg % 360) / 22.5)) % 16;
  return dirs[idx];
}
